import React from 'react';

import { IPlacementWindowSvgDataAttr, ISpinnerSvgDataChildrenAttr } from 'src/typings/spinner';
import { LayoutApartmentItem } from 'src/components/LayoutApartmentItem';
import {
  IFilterAllData, ListOfKeysFilterAllData, PlacementDisplayedType, PlacementShowModule,
} from 'src/typings/filter';
import { useAppVisibilityBtn, useBuildType } from 'src/hooks';
import Box from '@mui/material/Box';
import { ApartmentStatus2dView } from 'src/components/LayoutApartmentItem/components/ApartmentStatus2dView';
import {
  ApartmentSidebarActions,
} from 'src/components/CrosstableContent/components/AppartmentSidebarCross/components/ApartmentSidebarActions';
import { useSpinnerStyles } from './styles';
import { useGetPlacementPopoverData } from './hooks';

interface IPopoverInfo {
  attr?: ISpinnerSvgDataChildrenAttr | IPlacementWindowSvgDataAttr;
  placement?: IFilterAllData;
  handleClose: () => void;
}

export const PopoverInfo: React.FC<IPopoverInfo> = React.memo(({
  attr,
  placement,
  handleClose,
}) => {
  const styles = useSpinnerStyles({});
  const { isCrossTable } = useBuildType();
  const { property }: { property: IFilterAllData } = useGetPlacementPopoverData(attr, placement);
  const { filter_favorites } = useAppVisibilityBtn();
  const isDisabledLink = property && property[ListOfKeysFilterAllData.placementStatusShowInModule] === PlacementShowModule.hide;
  const isFavEnabled = (): boolean => {
    if (filter_favorites) {
      if (!isCrossTable) {
        return !isDisabledLink;
      }
      return true;
    }
    return false;
  };

  return (
    <>
      {!isCrossTable && (
        <div>
          {property && (
            <LayoutApartmentItem
              withSizeLimits
              withCloseButton
              withMoreButton
              isDisabledLink={isCrossTable ? false : isDisabledLink}
              isShowFavIcon={isFavEnabled()}
              wrapperStyle={styles.mapPopover}
              placementDisplayedType={isCrossTable ? PlacementDisplayedType.filter : PlacementDisplayedType.popup}
              property={property}
              onClosePopover={handleClose}
            />
          )}
        </div>
      )}
      {isCrossTable && (
        // Deal cards can make the popover taller than the window — cap the
        // height and scroll inside instead of overflowing past the bottom edge.
        <Box maxWidth="250px" minWidth="250px" maxHeight="calc(100vh - 48px)" overflow="auto">
          {property && (
            <>
              { isCrossTable && (
                <ApartmentStatus2dView
                  property={property}
                  onCloseClick={handleClose}
                />
              )}
              <Box>
                <ApartmentSidebarActions placement={property} />
                <Box padding="16px" display="flex" gap="16px" flexDirection="column">
                  <>
                    <LayoutApartmentItem
                      withSizeLimits
                      property={property}
                      isShowFavIcon={false}
                      withBitrixDeal
                    />
                  </>
                </Box>
              </Box>
            </>
          )}
        </Box>
      )}
    </>
  );
});
